"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasPrivilege = void 0;
const exceptions_1 = require("../exceptions");
/**
 * Checks that an authenticated USER has a privilege. If a privilege is not defined, then this function will just check
 * that an authenticated user has been provided.
 *
 * @param user
 * @param privilege
 */
const hasPrivilege = (user, privilege, adminOnly) => __awaiter(void 0, void 0, void 0, function* () {
    if (!user) {
        throw new exceptions_1.AuthenticationException('Authentication Required', {
            isClientError: true,
            context: {
                type: 'AuthenticationRequired',
                mustAuthenticateAs: ['user'],
            },
        });
    }
    if (adminOnly && user.__typename == 'CUSTOMER') {
        throw new exceptions_1.AuthorizationException('Authorization Failed', {
            isClientError: true,
            context: {
                type: 'AuthorizationFailed',
                mustAuthenticateAs: ['admin'],
            },
        });
    }
    if (user.__typename == 'SERVICE' || typeof privilege == 'undefined')
        return true;
    if (user.roles) {
        for (const i in user.roles) {
            for (const x in user.roles[i].role.privileges) {
                if (user.roles[i].role.privileges[x].privilege.handle === privilege) {
                    return true;
                }
            }
        }
    }
    if (user.memberGroups) {
        for (const g in user.memberGroups) {
            for (const j in user.memberGroups[g].group.roles) {
                for (const y in user.memberGroups[g].group.roles[j].role.privileges) {
                    if (user.memberGroups[g].group.roles[j].role.privileges[y].privilege
                        .handle === privilege) {
                        return true;
                    }
                }
            }
        }
    }
    throw new exceptions_1.AuthorizationException(`User not permitted to perform '${privilege}'`, {
        isClientError: true,
        context: {
            permissionRequired: privilege,
        },
    });
});
exports.hasPrivilege = hasPrivilege;
